<template>
  <div class="tw-mb-2 tw-rounded tw-border tw-bg-white">
    <div
      class="tw-flex tw-items-center tw-justify-between tw-pr-3"
      :class="{
        'tw-border-b': isModuleOpen,
        'tw-cursor-not-allowed': isCurrentModuleInValid,
        'tw-cursor-pointer': !isCurrentModuleInValid
      }"
      @click="onClickModule"
    >
      <div class="tw-flex tw-items-center tw-px-3 tw-py-4">
        <TablerChevronRight
          :class="{
            'tw-mr-2 tw-h-4 tw-w-4': true,
            'tw-rotate-90': isModuleOpen
          }"
        />
        <h2 class="tw-text-xs tw-font-semibold" :data-testid="title.replaceAll(' ', '-').toLowerCase()">
          {{ title }}
        </h2>
      </div>
      <slot v-if="isModuleOpen && hasTooltipSlot" name="tooltip" class="tw-z-50" />
    </div>
    <div v-if="isModuleOpen" class="tw-p-4">
      <slot name="main" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapActions, mapState } from 'vuex';

import TablerChevronRight from '@/studioComponents/Icons/tabler/TablerChevronRight.vue';
import { isObjectEmpty } from '@/utils/utils';

export default defineComponent({
  name: 'ModuleWrapper',
  components: { TablerChevronRight },
  props: {
    moduleId: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  },
  mounted() {
    this.$emit('initializeData');
    this.changeView('monitor');
  },
  computed: {
    ...mapState('branding', ['currentModuleId', 'changesMadeInThemeObj', 'isCurrentModuleInValid']),
    isModuleOpen() {
      return this.currentModuleId === this.moduleId;
    },
    hasTooltipSlot() {
      return !!this.$slots.tooltip;
    }
  },
  watch: {
    isModuleOpen(isModuleOpenNew, isModuleOpenOld) {
      if (!isModuleOpenOld && isModuleOpenNew) {
        this.$emit('initializeData');
      }
    },
    changesMadeInThemeObj(newThemeObj) {
      if (isObjectEmpty(newThemeObj)) {
        this.$emit('initializeData');
      }
    },
    changesMadeInEvent(newThemeObj) {
      if (isObjectEmpty(newThemeObj)) {
        this.$emit('initializeData');
      }
    }
  },
  methods: {
    ...mapActions('branding', ['onSelectModule', 'changeView']),
    onClickModule() {
      if (this.isModuleOpen) {
        // close the module
        this.onSelectModule();
        return;
      }
      this.onSelectModule(this.moduleId);
    }
  }
});
</script>
